import React from 'react'
import template from 'lodash/template'
import { withRouter } from 'react-router'

export const withInjectURLParams = (Component) => {
  return withRouter(
    ({
      router: {
        location: {
          query: {
            amount,
            name,
            first_name,
            answer_1,
            answer_2,
            answer_3
          } = {}
        } = {}
      } = {},
      ...props
    }) => {
      const injectURLParams = (str) => template(str)({
        amount,
        name,
        first_name,
        answer_1,
        answer_2,
        answer_3
      })

      return (
        <Component
          injectURLParams={injectURLParams}
          {...props}
        />
      )
    }
  )
}

const InjectURLParams = withInjectURLParams(
  ({
    children,
    injectURLParams
  }) => (
    <span>
      {injectURLParams(children)}
    </span>
  )
)

export default InjectURLParams



// WEBPACK FOOTER //
// ./components/utils/InjectURLParams/index.js